"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Auth = _interopRequireDefault(require("composer-lib/data/model/Auth"));

var _ComposerSettings = _interopRequireDefault(require("composer-lib/data/model/ComposerSettings"));

var _Composition = _interopRequireDefault(require("composer-lib/data/model/Composition"));

var _lockHelpers = require("composer-lib/lib/helpers/lockHelpers");

var _ContentGroups = _interopRequireDefault(require("ComposeUI/data/model/ContentGroups"));

var _editorConfigs = require("composer-lib/lib/editorConfigs");

var _FavoriteBlog = _interopRequireDefault(require("ComposeUI/data/model/FavoriteBlog"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _utils = require("ComposeUI/lib/utils");

var _Lock = _interopRequireDefault(require("composer-lib/data/model/Lock"));

var _constants = require("ComposeUI/lib/constants");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _SaveState = _interopRequireDefault(require("composer-lib/data/model/SaveState"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogFooter = _interopRequireDefault(require("UIComponents/dialog/UIDialogFooter"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _usageTracker = require("ComposeUI/lib/usageTracker");

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H2"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var langKey = function langKey(key) {
  return "ComposeUI.composeEditInterstitialModal." + key;
};

var ComposeEditInterstitialModal = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(ComposeEditInterstitialModal, _PureComponent);

  function ComposeEditInterstitialModal() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ComposeEditInterstitialModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ComposeEditInterstitialModal)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleCompositionConvertClick = function () {
      _usageTracker.usageTracker.track('compositionConverted', {
        action: 'format-composition-clicked'
      });

      _this.convertCompositionToPost();
    };

    return _this;
  }

  (0, _createClass2.default)(ComposeEditInterstitialModal, [{
    key: "convertPostForEditor",
    value: function convertPostForEditor() {
      var _this$props = this.props,
          composerSettings = _this$props.composerSettings,
          composition = _this$props.composition,
          saveState = _this$props.saveState;
      var content = saveState.content,
          title = saveState.title;
      return composition.get('data').merge({
        buffer: false,
        postBody: (0, _editorConfigs.convertToHTML)(composerSettings)(content.getCurrentContent()),
        processingStatus: _constants.ProcessingStatus.FORMATTING,
        title: title
      });
    }
  }, {
    key: "preparePostForEditor",
    value: function preparePostForEditor() {
      var _this$props2 = this.props,
          auth = _this$props2.auth,
          lock = _this$props2.lock,
          saveState = _this$props2.saveState;
      var highlighted = saveState.highlighted,
          locked = saveState.locked;
      var lockedComposition = (0, _lockHelpers.compositionLocked)(lock, auth, saveState);

      if (highlighted || locked || lockedComposition) {
        return null;
      }

      return this.convertPostForEditor();
    }
  }, {
    key: "convertCompositionToPost",
    value: function convertCompositionToPost() {
      var _this$props3 = this.props,
          composition = _this$props3.composition,
          contentGroups = _this$props3.contentGroups,
          favoriteBlog = _this$props3.favoriteBlog,
          savePost = _this$props3.savePost;
      var contentGroupId = (0, _utils.getDefaultContentGroupId)(contentGroups, favoriteBlog, composition);
      var postData = this.preparePostForEditor();

      if (!postData) {
        return;
      }

      var contentGroup = contentGroups.data.find(function (_ref) {
        var id = _ref.id;
        return id === parseInt(contentGroupId, 10);
      });
      savePost(postData, contentGroup);
    }
  }, {
    key: "renderContinueButton",
    value: function renderContinueButton() {
      return _react.default.createElement(_UIButton.default, {
        onClick: this.handleCompositionConvertClick,
        use: "primary"
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: langKey('continue')
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          dismissModal = _this$props4.dismissModal,
          modalOpen = _this$props4.modalOpen;

      if (modalOpen !== _constants.ModalNames.COMPOSE_EDIT_INTERSTITIAL) {
        return null;
      }

      return _react.default.createElement(_UIModal.default, {
        size: "auto",
        use: "conversational",
        width: 580
      }, _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement(_H.default, {
        className: "compose-edit-modal-header"
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: langKey('header')
      }))), _react.default.createElement(_UIDialogBody.default, {
        className: "text-left"
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: langKey('body')
      })), _react.default.createElement(_UIDialogFooter.default, null, this.renderContinueButton(), _react.default.createElement(_UIButton.default, {
        onClick: dismissModal
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: langKey('cancel')
      }))));
    }
  }]);
  return ComposeEditInterstitialModal;
}(_react.PureComponent);

ComposeEditInterstitialModal.propTypes = {
  auth: _propTypes.default.instanceOf(_Auth.default).isRequired,
  composerSettings: _propTypes.default.instanceOf(_ComposerSettings.default).isRequired,
  composition: _propTypes.default.instanceOf(_Composition.default).isRequired,
  contentGroups: _propTypes.default.instanceOf(_ContentGroups.default).isRequired,
  dismissModal: _propTypes.default.func.isRequired,
  favoriteBlog: _propTypes.default.instanceOf(_FavoriteBlog.default),
  lock: _propTypes.default.instanceOf(_Lock.default),
  modalOpen: _propTypes.default.string,
  savePost: _propTypes.default.func.isRequired,
  saveState: _propTypes.default.instanceOf(_SaveState.default)
};
var _default = ComposeEditInterstitialModal;
exports.default = _default;
module.exports = exports.default;